import React from 'react';
import { Link } from 'react-scroll';

import { useTranslation } from 'gatsby-plugin-react-i18next';

import { parseEntities } from 'parse-entities';

import Arrow from 'common/icons/arrow.svg';
import { IParagraphCalloutStripe } from 'common/interfaces/landing.interface';

import './CalloutStripe.scss';

interface Props {
  item: IParagraphCalloutStripe;
  containerClass?: string;
  onClick?: () => void;
}

export const CalloutStripe: React.FC<Props> = ({ item, onClick, containerClass = '' }) => {
  const onCtaClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const { t } = useTranslation();

  return (
    <div className={`cta ${containerClass}`}>
      <div className="callout-stripe-copy">
        <div className="callout-stripe-text">
          <h4 className="callout-stripe-title">{parseEntities(item.field_description.value)}</h4>
          {item.field_secondary_description && (
            <p className="callout-stripe-paragraph">{parseEntities(item.field_secondary_description)}</p>
          )}
        </div>
      </div>
      <Link
        to="contact-form-container"
        href="#contact-form-container"
        key={item.field_title}
        className="callout-stripe-button"
        spy
        smooth
        duration={300}
        offset={-120}
        onClick={onCtaClick}
        aria-label={t('Contact us')!}
      >
        <span>{parseEntities(item.field_title)}</span>
        <Arrow />
      </Link>
    </div>
  );
};
